import React, { ComponentProps } from 'react';
import RealkreditDenmarkLogoSrc from 'src/assets/images/refsign-logo.svg';
import DanicaDKLogoSrc from 'src/assets/images/danica-logo.svg';
import NordaniaDenmarkLogoSrc from 'src/assets/images/nordania-logo.svg';
import DanskeBankLogoSrc from 'src/assets/images/Danske_Bank_Logo_CMYK.png';

import { Logo, LogoLink, LogoWrapper } from './styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

type Props = ComponentProps<typeof LogoLink>;

export const DanskeBankLogo = (props: Props) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  if (isFromMvpApp) {
    return (
      <LogoWrapper>
        <Logo src={DanskeBankLogoSrc} alt="Danske bank logo" />
      </LogoWrapper>
    );
  }

  return (
    <LogoLink {...props}>
      <Logo src={DanskeBankLogoSrc} alt="Danske bank logo" />
    </LogoLink>
  );
};

export const RealkreditDenmarkLogo = (props: Props) => (
  <LogoLink {...props}>
    <Logo src={RealkreditDenmarkLogoSrc} alt="Realkredit Denmark logo" />
  </LogoLink>
);

export const DanicaDKLogo = (props: Props) => (
  <LogoLink {...props}>
    <Logo src={DanicaDKLogoSrc} alt="Danica Denmark logo" />
  </LogoLink>
);

export const NordaniaDenmarkLogo = (props: Props) => (
  <LogoLink {...props}>
    <Logo src={NordaniaDenmarkLogoSrc} alt="Nordania Denmark logo" />
  </LogoLink>
);
